"use client";
import CustomNavLink from "@/components/CustomLink/CustomNavLink";
import { useDictionary } from "@/components/DictProvider/DictProvider";
import usePost from "@/hooks/usePost";
import Image from "next/image";
import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import { FormEvent, useState } from "react";
import toast from "react-hot-toast";

export default function DesktopFooter() {
  const dictionary = useDictionary();
  const [email, setEmail] = useState("");
  const router: any = useRouter();
  const currentPath: any = router.pathname;
  const pathName = usePathname();

  const { PostMethod } = usePost();

  const subscribeUs = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const res = await PostMethod({
        method: "post",
        url: "subscribe/add",
        body: { email },
      });

      if (res?.success) {
        toast.success(res?.message);
        return;
      }

      toast.success(res?.message);
    } catch (error: any) {
      toast.success(error?.message);
    }
  };

  const handleNavigation = (e: any, path: any) => {
    e.preventDefault();
    if (currentPath !== "/") {
      router.push(`/#${path}`); // Navigate to the home page with the hash
    } else {
      document
        .getElementById(`${path}`)
        ?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
     

      {/* NEW FOOTER — hidden below md; MobileFooter renders the compact mobile version */}
      <footer className="hidden md:flex w-full bg-[#000000] text-white justify-between items-stretch flex-wrap xl:flex-nowrap gap-8 px-4 py-12 md:p-14">
        {/* First */}
        <div className="w-full md:w-fit lg:w-[25%] order-2 md:order-1 flex flex-col justify-between gap-2">
          {/* social icons */}
          <div className="flex justify-center gap-3 flex-wrap md:hidden my-8">
            <Link
              href={"https://www.youtube.com/@CAMOUFLAGE-bo8he"}
              target="_blank"
              prefetch={false}
            >
              <svg
                className=""
                width="36"
                height="36"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="20" cy="20" r="20" fill="white" />
                <path
                  d="M18 23L23.19 20L18 17V23ZM29.56 15.17C29.69 15.64 29.78 16.27 29.84 17.07C29.91 17.87 29.94 18.56 29.94 19.16L30 20C30 22.19 29.84 23.8 29.56 24.83C29.31 25.73 28.73 26.31 27.83 26.56C27.36 26.69 26.5 26.78 25.18 26.84C23.88 26.91 22.69 26.94 21.59 26.94L20 27C15.81 27 13.2 26.84 12.17 26.56C11.27 26.31 10.69 25.73 10.44 24.83C10.31 24.36 10.22 23.73 10.16 22.93C10.09 22.13 10.06 21.44 10.06 20.84L10 20C10 17.81 10.16 16.2 10.44 15.17C10.69 14.27 11.27 13.69 12.17 13.44C12.64 13.31 13.5 13.22 14.82 13.16C16.12 13.09 17.31 13.06 18.41 13.06L20 13C24.19 13 26.8 13.16 27.83 13.44C28.73 13.69 29.31 14.27 29.56 15.17Z"
                  fill="black"
                />
              </svg>
            </Link>

            <Link
              href={
                "https://www.tiktok.com/@camouflage_kwt?_t=8mrbvkeSw24&_r=1"
              }
              target="_blank"
              prefetch={false}
            >
              <svg
                className=""
                width="36"
                height="36"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="20" cy="20" r="20" fill="white" />
                <path
                  d="M23.6 13.82C22.9164 13.0396 22.5397 12.0374 22.54 11H19.45V23.4C19.4261 24.071 19.1428 24.7066 18.6597 25.1729C18.1766 25.6393 17.5314 25.8999 16.86 25.9C15.44 25.9 14.26 24.74 14.26 23.3C14.26 21.58 15.92 20.29 17.63 20.82V17.66C14.18 17.2 11.16 19.88 11.16 23.3C11.16 26.63 13.92 29 16.85 29C19.99 29 22.54 26.45 22.54 23.3V17.01C23.793 17.9099 25.2973 18.3926 26.84 18.39V15.3C26.84 15.3 24.96 15.39 23.6 13.82Z"
                  fill="black"
                />
              </svg>
            </Link>

           

            <Link
              href={
                "https://www.linkedin.com/in/camouflage-for-hunting-and-fishing-845b2b244/?originalSubdomain=kw"
              }
              target="_blank"
              prefetch={false}
            >
              <svg
                className=""
                width="36"
                height="36"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="20" cy="20" r="20" fill="white" />
                <path
                  d="M14.94 13C14.9397 13.5305 14.7288 14.0391 14.3535 14.4139C13.9782 14.7888 13.4694 14.9993 12.939 14.999C12.4086 14.9988 11.9 14.7878 11.5251 14.4125C11.1502 14.0373 10.9397 13.5285 10.94 12.998C10.9403 12.4676 11.1512 11.959 11.5265 11.5841C11.9018 11.2092 12.4106 10.9988 12.941 10.999C13.4714 10.9993 13.98 11.2103 14.3549 11.5855C14.7298 11.9608 14.9403 12.4696 14.94 13ZM15 16.48H11V29H15V16.48ZM21.32 16.48H17.34V29H21.28V22.43C21.28 18.77 26.05 18.43 26.05 22.43V29H30V21.07C30 14.9 22.94 15.13 21.28 18.16L21.32 16.48Z"
                  fill="black"
                />
              </svg>
            </Link>

            <Link
              href={
                "https://www.facebook.com/share/EUL38efQ2KyyLkdv/?mibextid=LQQJ4d"
              }
              target="_blank"
              prefetch={false}
            >
              <svg
                className=""
                width="36"
                height="36"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="20" cy="20" r="20" fill="white" />
                <path
                  d="M21.397 28.9972V20.8012H24.162L24.573 17.5922H21.397V15.5482C21.397 14.6222 21.655 13.9882 22.984 13.9882H24.668V11.1272C23.8486 11.0394 23.025 10.997 22.201 11.0002C19.757 11.0002 18.079 12.4922 18.079 15.2312V17.5862H15.332V20.7952H18.085V28.9972H21.397Z"
                  fill="black"
                />
              </svg>
            </Link>
            <Link
              href={
                "https://www.instagram.com/camouflage_kwt/?igshid=1lfuqokhivzxa"
              }
              target="_blank"
              prefetch={false}
            >
              <svg
                className=""
                width="36"
                height="36"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="20" cy="20" r="20" fill="white" />
                <path
                  d="M15.8 10H24.2C27.4 10 30 12.6 30 15.8V24.2C30 25.7383 29.3889 27.2135 28.3012 28.3012C27.2135 29.3889 25.7383 30 24.2 30H15.8C12.6 30 10 27.4 10 24.2V15.8C10 14.2617 10.6111 12.7865 11.6988 11.6988C12.7865 10.6111 14.2617 10 15.8 10ZM15.6 12C14.6452 12 13.7295 12.3793 13.0544 13.0544C12.3793 13.7295 12 14.6452 12 15.6V24.4C12 26.39 13.61 28 15.6 28H24.4C25.3548 28 26.2705 27.6207 26.9456 26.9456C27.6207 26.2705 28 25.3548 28 24.4V15.6C28 13.61 26.39 12 24.4 12H15.6ZM25.25 13.5C25.5815 13.5 25.8995 13.6317 26.1339 13.8661C26.3683 14.1005 26.5 14.4185 26.5 14.75C26.5 15.0815 26.3683 15.3995 26.1339 15.6339C25.8995 15.8683 25.5815 16 25.25 16C24.9185 16 24.6005 15.8683 24.3661 15.6339C24.1317 15.3995 24 15.0815 24 14.75C24 14.4185 24.1317 14.1005 24.3661 13.8661C24.6005 13.6317 24.9185 13.5 25.25 13.5ZM20 15C21.3261 15 22.5979 15.5268 23.5355 16.4645C24.4732 17.4021 25 18.6739 25 20C25 21.3261 24.4732 22.5979 23.5355 23.5355C22.5979 24.4732 21.3261 25 20 25C18.6739 25 17.4021 24.4732 16.4645 23.5355C15.5268 22.5979 15 21.3261 15 20C15 18.6739 15.5268 17.4021 16.4645 16.4645C17.4021 15.5268 18.6739 15 20 15ZM20 17C19.2044 17 18.4413 17.3161 17.8787 17.8787C17.3161 18.4413 17 19.2044 17 20C17 20.7956 17.3161 21.5587 17.8787 22.1213C18.4413 22.6839 19.2044 23 20 23C20.7956 23 21.5587 22.6839 22.1213 22.1213C22.6839 21.5587 23 20.7956 23 20C23 19.2044 22.6839 18.4413 22.1213 17.8787C21.5587 17.3161 20.7956 17 20 17Z"
                  fill="black"
                />
              </svg>
            </Link>
            <Link
              href="https://wa.me/96594979199"
              target="_blank"
              prefetch={false}
            >
              <svg
                width="36"
                height="36"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="20" cy="20" r="20" fill="white" />
                <path
                  d="M20.05 10C14.53 10 10.05 14.48 10.05 20C10.05 21.85 10.55 23.55 11.43 25.04L10 30L15.09 28.59C16.52 29.38 18.23 29.98 20.05 29.98C25.53 29.98 30 25.52 30 20C30 17.34 28.95 14.84 27.07 12.93C25.18 11.05 22.68 10 20.05 10ZM20.05 12C22.15 12 24.12 12.84 25.66 14.34C27.16 15.88 28 17.87 28 20C28 24.41 24.41 28 20.05 28C18.49 28 17.06 27.58 15.81 26.84L15.42 26.61L12.29 27.41L13.09 24.37L12.84 23.95C12.01 22.64 11.55 21.12 11.55 19.5L12.05 20C12.05 15.59 15.59 12 20.05 12ZM16.54 15.5C16.36 15.5 16.06 15.57 15.81 15.84C15.55 16.1 14.83 16.78 14.83 18.15C14.83 19.53 15.83 20.85 15.97 21.05C16.12 21.24 17.93 24.08 20.76 25.13C21.37 25.37 21.85 25.5 22.22 25.6C22.83 25.78 23.39 25.76 23.82 25.69C24.31 25.6 25.16 25.01 25.38 24.35C25.59 23.7 25.59 23.14 25.52 23.02C25.45 22.91 25.26 22.84 24.97 22.7C24.68 22.55 23.31 21.88 23.05 21.78C22.79 21.68 22.61 21.63 22.42 21.92C22.23 22.2 21.7 22.84 21.54 23.02C21.39 23.21 21.23 23.23 20.94 23.09C20.65 22.94 19.74 22.64 18.66 21.68C17.82 20.93 17.24 20.01 17.09 19.72C16.94 19.43 17.07 19.27 17.22 19.13C17.35 19 17.51 18.79 17.65 18.64C17.8 18.49 17.84 18.38 17.95 18.19C18.05 18 18 17.84 17.93 17.7C17.85 17.55 17.26 16.18 17.03 15.69C16.8 15.22 16.56 15.5 16.54 15.5Z"
                  fill="black"
                />
              </svg>
            </Link>
          </div>
          {/* Camouflage Logo */}
          <div
            className="flex justify-center md:justify-start"
            onClick={(e) => handleNavigation(e, "homeNav")}
          >
            <Image
              src={"/images/whitelogo.png"}
              width={120}
              height={80}
              alt="logo"
              unoptimized
            />
          </div>
          {/* conatact and email */}
          <div className="flex justify-center md:justify-start gap-4 mt-4 flex-wrap">
            <Link href={"tel:+96594979199"} prefetch={false}>
              <svg
                width="36"
                height="36"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="20" cy="20" r="20" fill="white" />
                <path
                  d="M29.275 30.5C26.8444 30.5 24.4431 29.9703 22.0708 28.911C19.6986 27.8517 17.5403 26.3494 15.5958 24.4042C13.6514 22.4597 12.1495 20.3014 11.0902 17.9292C10.0308 15.5569 9.50078 13.1556 9.5 10.725C9.5 10.375 9.61667 10.0833 9.85 9.85C10.0833 9.61667 10.375 9.5 10.725 9.5H15.45C15.7222 9.5 15.9653 9.59256 16.1792 9.77767C16.3931 9.96278 16.5194 10.1813 16.5583 10.4333L17.3167 14.5167C17.3556 14.8278 17.3458 15.0903 17.2875 15.3042C17.2292 15.5181 17.1222 15.7028 16.9667 15.8583L14.1375 18.7167C14.5264 19.4361 14.988 20.1311 15.5223 20.8015C16.0567 21.4719 16.6451 22.1187 17.2875 22.7417C17.8903 23.3444 18.5222 23.9037 19.1833 24.4193C19.8444 24.935 20.5444 25.4063 21.2833 25.8333L24.025 23.0917C24.2 22.9167 24.4287 22.7856 24.711 22.6985C24.9933 22.6114 25.2702 22.5869 25.5417 22.625L29.5667 23.4417C29.8389 23.5194 30.0625 23.6606 30.2375 23.8652C30.4125 24.0697 30.5 24.298 30.5 24.55V29.275C30.5 29.625 30.3833 29.9167 30.15 30.15C29.9167 30.3833 29.625 30.5 29.275 30.5Z"
                  fill="black"
                />
              </svg>
            </Link>

            <Link href={"mailto:info@camouflage.com.kw"} prefetch={false}>
              <svg
                className=""
                width="36"
                height="36"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="20" cy="20" r="20" fill="white" />
                <path
                  d="M11 13.25V25.25C11 25.6478 11.158 26.0294 11.4393 26.3107C11.7206 26.592 12.1022 26.75 12.5 26.75H27.5C27.8978 26.75 28.2794 26.592 28.5607 26.3107C28.842 26.0294 29 25.6478 29 25.25V13.25H11ZM11 11.75H29C29.3978 11.75 29.7794 11.908 30.0607 12.1893C30.342 12.4706 30.5 12.8522 30.5 13.25V25.25C30.5 26.0456 30.1839 26.8087 29.6213 27.3713C29.0587 27.9339 28.2956 28.25 27.5 28.25H12.5C11.7044 28.25 10.9413 27.9339 10.3787 27.3713C9.81607 26.8087 9.5 26.0456 9.5 25.25V13.25C9.5 12.8522 9.65804 12.4706 9.93934 12.1893C10.2206 11.908 10.6022 11.75 11 11.75Z"
                  fill="black"
                />
                <path
                  d="M29.1875 13.25L23.387 19.88C22.9646 20.3628 22.4439 20.7498 21.8598 21.0149C21.2756 21.28 20.6415 21.4172 20 21.4172C19.3585 21.4172 18.7244 21.28 18.1402 21.0149C17.5561 20.7498 17.0354 20.3628 16.613 19.88L10.8125 13.25H29.1875ZM12.806 13.25L17.741 18.8915C18.0226 19.2135 18.3698 19.4715 18.7592 19.6483C19.1487 19.8251 19.5715 19.9166 19.9992 19.9166C20.427 19.9166 20.8498 19.8251 21.2393 19.6483C21.6287 19.4715 21.9759 19.2135 22.2575 18.8915L27.194 13.25H12.806Z"
                  fill="black"
                />
              </svg>
            </Link>
          </div>
          {/* contactus and policy */}
          <div className="flex justify-center md:justify-start gap-2 flex-wrap">
            <p className="text-base leading-6 ltr:text-left rtl:text-right">
              <CustomNavLink href="contact-us">
                {dictionary?.footerPage.contactus}
              </CustomNavLink>
            </p>
            <p className="text-base leading-6 ltr:text-left rtl:text-right">
              <CustomNavLink href="privacy-and-policy">
                {dictionary?.footerPage.privacyPolicy}
              </CustomNavLink>
            </p>
          </div>
          {/* address */}
          <div className="flex justify-center md:justify-start flex-wrap">
            <p className="text-base leading-6 ltr:text-left rtl:text-right">
              {dictionary?.footerPage.address1}
            </p>
            <p className="text-base leading-6 ltr:text-left rtl:text-right">
              {dictionary?.footerPage.address2}{" "}
            </p>
          </div>
          {/* Policy */}
          <div className="flex gap-x-3 justify-center flex-wrap my-6 text-sm md:hidden">
            <CustomNavLink href="delivery-policy">
              <p>{dictionary?.footerPage?.deliveryPolicy}</p>
            </CustomNavLink>
            <CustomNavLink href="refundpolicy">
              <p>{dictionary?.footerPage?.refundPolicy}</p>
            </CustomNavLink>
            <CustomNavLink href="general-condition">
              <p>{dictionary?.footerPage?.generalPolicy}</p>
            </CustomNavLink>
          </div>
        </div>
        {/* Second */}
        <div className="w-full md:w-fit lg:w-[50%] order-1 md:order-3 xl:order-2 flex flex-col justify-between items-center md:items-start xl:items-center gap-2">
          {/* subscribe us with icons */}
          <div className="flex flex-col justify-start items-center md:items-start xl:items-center gap-4">
            <form
              onSubmit={subscribeUs}
              className="w-full flex justify-center md:justify-start xl:justify-center"
            >
              <input
                required
                type="email"
                autoComplete="off"
                name="price"
                id="price"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                className="focus:outline-none w-[calc(100%-120px)] md:w-8/12 rounded-md border-0 py-2 ltr:lg:pl-5  ltr:pl-2 rtl:pr-2 ltr:lg:pr-20 rtl:md:pr-5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-0 focus-visible:ring-0 sm:leading-6"
                placeholder={`${dictionary?.footerPage?.enteremail}.`}
              />
              <button
                type="submit"
                className="px-4 py-2 w-[120px] h-[40px] ltr:ml-8  rtl:mr-8  bg-primary rounded-md border-0"
              >
                {dictionary?.footerPage.subscribe}
              </button>
            </form>
            <h4 className="w-full text-xl text-center md:text-left xl:text-center font-bold md:w-9/12">
              {dictionary?.footerPage.tag}{" "}
            </h4>
          </div>
          {/* Payments icons and all rights reserved */}
          <div className="hidden md:flex flex-col justify-start items-center md:items-start xl:items-center gap-2 mt-auto md:mt-4 xl:mt-auto">
            <Image
              src={"/images/payment-image1.svg"}
              width={350}
              height={64}
              alt="payment"
              unoptimized
            />
            <h6 className="text-center">
              &#169;{" "}
              {`${
                pathName?.split("/")[1] === "en"
                  ? new Date().getFullYear()
                  : new Date()
                      .getFullYear()
                      ?.toString()
                      .split("")
                      .map((digit) =>
                        String.fromCharCode(0x0660 + parseInt(digit))
                      )
                      .join("")
              } ${dictionary?.footerPage.copyright}`}
            </h6>
          </div>
        </div>
        {/* Third */}
        <div className="w-full md:w-fit lg:w-[25%] order-3 md:order-2 xl:order-3 flex flex-col justify-between gap-4 xl:gap-2 xl:items-end">
          <div className="flex flex-row md:flex-col justify-center gap-8 md:gap-4 flex-wrap">
            <a
              href="https://play.google.com/store/apps/details?id=com.camouflagekw"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                src={"/images/playstorestr.svg"}
                width={150}
                height={40}
                alt="playstore"
              />
            </a>
            <a
              href="https://apps.apple.com/in/app/camouflage/id6738765156"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                src={"/images/iphonestr.svg"}
                width={150}
                height={40}
                alt="appstore"
              />
            </a>
          </div>
          <div className="flex flex-col justify-end gap-4">
            <div className="md:flex justify-between gap-x-3 hidden">
              <Link
                href={"https://www.youtube.com/@CAMOUFLAGE-bo8he"}
                target="_blank"
                prefetch={false}
              >
                <svg
                  className=""
                  width="36"
                  height="36"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="20" cy="20" r="20" fill="white" />
                  <path
                    d="M18 23L23.19 20L18 17V23ZM29.56 15.17C29.69 15.64 29.78 16.27 29.84 17.07C29.91 17.87 29.94 18.56 29.94 19.16L30 20C30 22.19 29.84 23.8 29.56 24.83C29.31 25.73 28.73 26.31 27.83 26.56C27.36 26.69 26.5 26.78 25.18 26.84C23.88 26.91 22.69 26.94 21.59 26.94L20 27C15.81 27 13.2 26.84 12.17 26.56C11.27 26.31 10.69 25.73 10.44 24.83C10.31 24.36 10.22 23.73 10.16 22.93C10.09 22.13 10.06 21.44 10.06 20.84L10 20C10 17.81 10.16 16.2 10.44 15.17C10.69 14.27 11.27 13.69 12.17 13.44C12.64 13.31 13.5 13.22 14.82 13.16C16.12 13.09 17.31 13.06 18.41 13.06L20 13C24.19 13 26.8 13.16 27.83 13.44C28.73 13.69 29.31 14.27 29.56 15.17Z"
                    fill="black"
                  />
                </svg>
              </Link>

              <Link
                href={
                  "https://www.tiktok.com/@camouflage_kwt?_t=8mrbvkeSw24&_r=1"
                }
                target="_blank"
                prefetch={false}
              >
                <svg
                  className=""
                  width="36"
                  height="36"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="20" cy="20" r="20" fill="white" />
                  <path
                    d="M23.6 13.82C22.9164 13.0396 22.5397 12.0374 22.54 11H19.45V23.4C19.4261 24.071 19.1428 24.7066 18.6597 25.1729C18.1766 25.6393 17.5314 25.8999 16.86 25.9C15.44 25.9 14.26 24.74 14.26 23.3C14.26 21.58 15.92 20.29 17.63 20.82V17.66C14.18 17.2 11.16 19.88 11.16 23.3C11.16 26.63 13.92 29 16.85 29C19.99 29 22.54 26.45 22.54 23.3V17.01C23.793 17.9099 25.2973 18.3926 26.84 18.39V15.3C26.84 15.3 24.96 15.39 23.6 13.82Z"
                    fill="black"
                  />
                </svg>
              </Link>

            
              <Link
                href={
                  "https://www.linkedin.com/in/camouflage-for-hunting-and-fishing-845b2b244/?originalSubdomain=kw"
                }
                target="_blank"
                prefetch={false}
              >
                <svg
                  className=""
                  width="36"
                  height="36"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="20" cy="20" r="20" fill="white" />
                  <path
                    d="M14.94 13C14.9397 13.5305 14.7288 14.0391 14.3535 14.4139C13.9782 14.7888 13.4694 14.9993 12.939 14.999C12.4086 14.9988 11.9 14.7878 11.5251 14.4125C11.1502 14.0373 10.9397 13.5285 10.94 12.998C10.9403 12.4676 11.1512 11.959 11.5265 11.5841C11.9018 11.2092 12.4106 10.9988 12.941 10.999C13.4714 10.9993 13.98 11.2103 14.3549 11.5855C14.7298 11.9608 14.9403 12.4696 14.94 13ZM15 16.48H11V29H15V16.48ZM21.32 16.48H17.34V29H21.28V22.43C21.28 18.77 26.05 18.43 26.05 22.43V29H30V21.07C30 14.9 22.94 15.13 21.28 18.16L21.32 16.48Z"
                    fill="black"
                  />
                </svg>
              </Link>

              <Link
                href={
                  "https://www.facebook.com/share/EUL38efQ2KyyLkdv/?mibextid=LQQJ4d"
                }
                target="_blank"
                prefetch={false}
              >
                <svg
                  className=""
                  width="36"
                  height="36"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="20" cy="20" r="20" fill="white" />
                  <path
                    d="M21.397 28.9972V20.8012H24.162L24.573 17.5922H21.397V15.5482C21.397 14.6222 21.655 13.9882 22.984 13.9882H24.668V11.1272C23.8486 11.0394 23.025 10.997 22.201 11.0002C19.757 11.0002 18.079 12.4922 18.079 15.2312V17.5862H15.332V20.7952H18.085V28.9972H21.397Z"
                    fill="black"
                  />
                </svg>
              </Link>
              <Link
                href={
                  "https://www.instagram.com/camouflage_kwt/?igshid=1lfuqokhivzxa"
                }
                target="_blank"
                prefetch={false}
              >
                <svg
                  className=""
                  width="36"
                  height="36"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="20" cy="20" r="20" fill="white" />
                  <path
                    d="M15.8 10H24.2C27.4 10 30 12.6 30 15.8V24.2C30 25.7383 29.3889 27.2135 28.3012 28.3012C27.2135 29.3889 25.7383 30 24.2 30H15.8C12.6 30 10 27.4 10 24.2V15.8C10 14.2617 10.6111 12.7865 11.6988 11.6988C12.7865 10.6111 14.2617 10 15.8 10ZM15.6 12C14.6452 12 13.7295 12.3793 13.0544 13.0544C12.3793 13.7295 12 14.6452 12 15.6V24.4C12 26.39 13.61 28 15.6 28H24.4C25.3548 28 26.2705 27.6207 26.9456 26.9456C27.6207 26.2705 28 25.3548 28 24.4V15.6C28 13.61 26.39 12 24.4 12H15.6ZM25.25 13.5C25.5815 13.5 25.8995 13.6317 26.1339 13.8661C26.3683 14.1005 26.5 14.4185 26.5 14.75C26.5 15.0815 26.3683 15.3995 26.1339 15.6339C25.8995 15.8683 25.5815 16 25.25 16C24.9185 16 24.6005 15.8683 24.3661 15.6339C24.1317 15.3995 24 15.0815 24 14.75C24 14.4185 24.1317 14.1005 24.3661 13.8661C24.6005 13.6317 24.9185 13.5 25.25 13.5ZM20 15C21.3261 15 22.5979 15.5268 23.5355 16.4645C24.4732 17.4021 25 18.6739 25 20C25 21.3261 24.4732 22.5979 23.5355 23.5355C22.5979 24.4732 21.3261 25 20 25C18.6739 25 17.4021 24.4732 16.4645 23.5355C15.5268 22.5979 15 21.3261 15 20C15 18.6739 15.5268 17.4021 16.4645 16.4645C17.4021 15.5268 18.6739 15 20 15ZM20 17C19.2044 17 18.4413 17.3161 17.8787 17.8787C17.3161 18.4413 17 19.2044 17 20C17 20.7956 17.3161 21.5587 17.8787 22.1213C18.4413 22.6839 19.2044 23 20 23C20.7956 23 21.5587 22.6839 22.1213 22.1213C22.6839 21.5587 23 20.7956 23 20C23 19.2044 22.6839 18.4413 22.1213 17.8787C21.5587 17.3161 20.7956 17 20 17Z"
                    fill="black"
                  />
                </svg>
              </Link>
              <Link
                href="https://wa.me/96594979199"
                target="_blank"
                prefetch={false}
              >
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="20" cy="20" r="20" fill="white" />
                  <path
                    d="M20.05 10C14.53 10 10.05 14.48 10.05 20C10.05 21.85 10.55 23.55 11.43 25.04L10 30L15.09 28.59C16.52 29.38 18.23 29.98 20.05 29.98C25.53 29.98 30 25.52 30 20C30 17.34 28.95 14.84 27.07 12.93C25.18 11.05 22.68 10 20.05 10ZM20.05 12C22.15 12 24.12 12.84 25.66 14.34C27.16 15.88 28 17.87 28 20C28 24.41 24.41 28 20.05 28C18.49 28 17.06 27.58 15.81 26.84L15.42 26.61L12.29 27.41L13.09 24.37L12.84 23.95C12.01 22.64 11.55 21.12 11.55 19.5L12.05 20C12.05 15.59 15.59 12 20.05 12ZM16.54 15.5C16.36 15.5 16.06 15.57 15.81 15.84C15.55 16.1 14.83 16.78 14.83 18.15C14.83 19.53 15.83 20.85 15.97 21.05C16.12 21.24 17.93 24.08 20.76 25.13C21.37 25.37 21.85 25.5 22.22 25.6C22.83 25.78 23.39 25.76 23.82 25.69C24.31 25.6 25.16 25.01 25.38 24.35C25.59 23.7 25.59 23.14 25.52 23.02C25.45 22.91 25.26 22.84 24.97 22.7C24.68 22.55 23.31 21.88 23.05 21.78C22.79 21.68 22.61 21.63 22.42 21.92C22.23 22.2 21.7 22.84 21.54 23.02C21.39 23.21 21.23 23.23 20.94 23.09C20.65 22.94 19.74 22.64 18.66 21.68C17.82 20.93 17.24 20.01 17.09 19.72C16.94 19.43 17.07 19.27 17.22 19.13C17.35 19 17.51 18.79 17.65 18.64C17.8 18.49 17.84 18.38 17.95 18.19C18.05 18 18 17.84 17.93 17.7C17.85 17.55 17.26 16.18 17.03 15.69C16.8 15.22 16.56 15.5 16.54 15.5Z"
                    fill="black"
                  />
                </svg>
              </Link>
            </div>
            <div className="md:flex gap-x-3 justify-between text-xs hidden">
              <CustomNavLink href="delivery-policy">
                <p className="text-nowrap">
                  {dictionary?.footerPage?.deliveryPolicy}
                </p>
              </CustomNavLink>
              <CustomNavLink href="refundpolicy">
                <p className="text-nowrap">
                  {dictionary?.footerPage?.refundPolicy}
                </p>
              </CustomNavLink>
              <CustomNavLink href="general-condition">
                <p className="text-nowrap">
                  {dictionary?.footerPage?.generalPolicy}
                </p>
              </CustomNavLink>
            </div>
          </div>
          {/* Payments icons and all rights reserved */}
          <div className="md:hidden flex flex-col mt-6 justify-start items-center md:items-start xl:items-center gap-2">
            <Image
              src={"/images/payment-image-mobile.svg"}
              width={350}
              height={64}
              alt="payment"
              unoptimized
            />
            <h6 className="text-lg text-center">
              &#169;{" "}
              {`${
                pathName?.split("/")[1] === "en"
                  ? new Date().getFullYear()
                  : new Date()
                      .getFullYear()
                      ?.toString()
                      .split("")
                      .map((digit) =>
                        String.fromCharCode(0x0660 + parseInt(digit))
                      )
                      .join("")
              } ${dictionary?.footerPage.copyright}`}
            </h6>
          </div>
        </div>
      </footer>
    </>
  );
}
